import { z } from 'zod'

function optionalUuidParam(): z.ZodType<string | undefined> {
  return z
    .string()
    .optional()
    .transform((v) => {
      if (v == null || v === '') return undefined
      return z.string().uuid().safeParse(v).success ? v : undefined
    })
}

export const checklistRunsSearchSchema = z.object({
  page: z.coerce.number().int().min(0).catch(0),
  page_size: z.coerce.number().int().min(1).max(100).catch(20),
  sort: z
    .enum(['completed_at', 'employee', 'machine', 'checklist', 'checks'])
    .catch('completed_at'),
  dir: z.enum(['asc', 'desc']).catch('desc'),
  search: z.string().catch(''),
  employee_code: z.string().catch(''),
  machine_id: optionalUuidParam(),
  checklist_id: optionalUuidParam(),
  segment: z
    .enum(['all', 'unread', 'incomplete', 'complete'])
    .catch('all'),
})

export type ChecklistRunsSearch = z.infer<typeof checklistRunsSearchSchema>

export function parseChecklistRunsSearch(
  raw: Record<string, unknown>,
): ChecklistRunsSearch {
  const parsed = checklistRunsSearchSchema.safeParse(raw)
  if (parsed.success) return parsed.data
  return checklistRunsSearchSchema.parse({})
}
